import * as React from "react";
import {
    Avatar,
    Box, Card, Container, IconButton, Typography,
} from "@mui/material";
import ButtonComponent from "components/Button";
import TextFieldComponent from "components/TextField";
import {
    getButtonDataSendInternalMsg,
    getTextfieldDataInternalMessage,
    schema,

} from "./helper";
import {
    checkUserAllowed,
    getLocalDate,
    openInstagram,
} from "helpers/utils";
import { H2, H5, H6 } from "components/CustomTypography";
import MockGeneralHeader from "components/elements/main/MockGeneralHeader";
import { handleExternalPage } from "services/utils";
import { DATE_FORMAT_SHORT, DATE_TIME_FORMAT_SHORT } from "config/constants";
import ImageAlbumAdmin from "components/elements/main/ImageAlbumAdmin";
import CustomSectionCreator from "components/CustomSectionCreator";
import InstagramIcon from '@mui/icons-material/Instagram';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions";
import { useEffect } from "react";


const AdminSellerShopDetail = (props) => {

    const { adminGetShopInfoById, shopId, isLoading, shopdetail, userDetails } = props;

    useEffect(() => {
        adminGetShopInfoById(shopId);
    }, []);

    const url = (shopdetail.domain && shopdetail.subdomain) ? "https://" + shopdetail.subdomain + "." + shopdetail.domain : "";


    const renderShopInformation = () => (
        <>
            <Box mt={2}>
                <H2 textAlign="left" title={shopdetail.title} ellipsis>
                    {shopdetail.title}
                </H2>
                <H5>
                    {shopdetail.addressline}
                </H5>
                <H5>
                    {shopdetail.areaname} {shopdetail.cityname}
                </H5>
                <H5>
                    {shopdetail.area} {shopdetail.city}
                </H5>
                <H5>
                    {shopdetail.phone}
                </H5>
                <H5>
                    <Box width="100%">
                        <Box>{!isLoading && <a href="#" onClick={handleExternalPage(url)}>{`${url || ""}`}</a>}</Box>
                        <Box width="100%" display="flex">
                            <Box width="50%" >
                                {!isLoading && (<div>
                                    <ButtonComponent
                                        sx={{
                                            mt: 2,
                                            mb: 2,
                                        }}
                                        type="primary"
                                        variant="contained"
                                        name="Visit Online Shop"
                                        size="small"
                                        onClick={handleExternalPage(url)}
                                    />
                                </div>)
                                }
                            </Box>
                            <Box width="50%" >

                            </Box>
                        </Box>
                    </Box>
                </H5>

            </Box>
            <Box mt={2} mb={2}>
                <Box width="100%" display="flex">
                    <Box width="30%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            Contact Name:
                        </H5>
                    </Box>
                    <Box width="70%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            {shopdetail.user && shopdetail.user.name}
                        </H5>
                    </Box>
                </Box>
                <Box width="100%" display="flex">
                    <Box width="30%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            Phone/Email:
                        </H5>
                    </Box>
                    <Box width="70%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            {shopdetail.user && (shopdetail.user.mobile + " " + shopdetail.user.email)}
                        </H5>
                    </Box>
                </Box>
                <Box width="100%" display="flex">
                    <Box width="30%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            Added on:
                        </H5>
                    </Box>
                    <Box width="70%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            {getLocalDate(shopdetail.created_at, DATE_TIME_FORMAT_SHORT)}
                        </H5>
                    </Box>
                </Box>
            </Box>
            <Box mt={2} mb={2}>
                <Box width="100%" display="flex">
                    <Box width="30%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            High Priority:
                        </H5>
                    </Box>
                    <Box width="70%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            {shopdetail.is_tracked && "TRUE"}
                        </H5>
                    </Box>
                </Box>
                <Box width="100%" display="flex">
                    <Box width="30%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            Insta followers:
                        </H5>
                    </Box>
                    <Box width="70%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            {shopdetail.instagram_followers_count}
                        </H5>
                    </Box>
                </Box>
                <Box width="100%" display="flex">
                    <Box width="30%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            Insta:
                        </H5>
                    </Box>
                    <Box width="70%" >
                        {shopdetail.instahandle}
                        {shopdetail.instahandle && <IconButton
                            size="small"
                            onClick={() => openInstagram(shopdetail.instahandle)}
                        >
                            <InstagramIcon sx={{ width: 20, height: 20 }} color="primary" />
                        </IconButton>}
                    </Box>
                </Box>
            </Box>
        </>
    );

    const renderSalesLeadPhotos = () => (
        <Box mb={4}>
            <CustomSectionCreator isSubtle={true} title="Sales Lead Photos" />
            <ImageAlbumAdmin showLink={checkUserAllowed(userDetails.userlevel, "approveshop")} images={shopdetail.saleslead && shopdetail.saleslead.images} />
        </Box>
    );


    const renderShopSentMessages = () => (
        <Box>
            <Box mb={2} width="100%">
                {shopdetail.messages && shopdetail.messages.map((messageItem, index) => (
                    <Box width="100%" display="flex">
                        <Box width="30%">
                            <H5 fontSize={14} textAlign="left" ellipsis>
                                {getLocalDate(messageItem.added_at, DATE_FORMAT_SHORT)} ({messageItem.added_by && messageItem.added_by.name})
                            </H5>
                        </Box>
                        <Box width="70%">
                            <H5 fontSize={14} textAlign="left" ellipsis>
                                {messageItem.message}
                            </H5>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );

    return (
        <Container>
            <Container maxWidth="md">
                {isLoading && <Box m={10}><MockGeneralHeader /></Box>}
                {!isLoading && renderShopInformation()}

                <Box mb={2}>
                    {(checkUserAllowed(userDetails.userlevel, "approveshop")) && renderShopSentMessages()}
                    {renderSalesLeadPhotos()}

                </Box>
            </Container>
        </Container>
    );
};

AdminSellerShopDetail.propTypes = {
    searchkeywords: PropTypes.objectOf(PropTypes.any).isRequired,
    adminSearchShopKeywords: PropTypes.func.isRequired,
};

// Mapping Props and State.
const adminSellerShopDetail = connect(
    ({ adminShops, bootupInfo }) => ({
        userDetails: bootupInfo.userDetails,
        reqStatus: adminShops.reqStatus,
        isLoading: adminShops.isLoading,
        serviceError: adminShops.serviceError,
        shopdetail: adminShops.shopDetail,
    }),
    (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(AdminSellerShopDetail);

export { adminSellerShopDetail as default };
